<template>
  <div>
    <button class="phone-button">
      <i class="fas fa-phone"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "PhoneButton"
};
</script>

<style scoped>
button {
  background-color: transparent;
  border: none;
  outline: none;
  color: var(--blue-grey);
  cursor: pointer;
  margin-top: 0px!important;
}

.clasic button {
  color: var(--green-button);
}
</style>